
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "../ui/button";
import { ArrowLeft } from "lucide-react";

interface ErrorStateProps {
  message: string | null;
}

const ErrorState = ({ message }: ErrorStateProps) => {
  const navigate = useNavigate();

  return (
    <div className="text-center py-12">
      <h2 className="text-2xl font-bold text-nalc-dark dark:text-white mb-4">
        {message || "Student not found"}
      </h2>
      <p className="text-muted-foreground mb-6">
        The student you're looking for doesn't exist or couldn't be loaded.
      </p>
      <Button 
        variant="outline" 
        onClick={() => navigate("/students")}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to Students
      </Button>
    </div>
  );
};

export default ErrorState;
